export default __webpack_public_path__ + "static/media/hrd.6ea71570.png";